import React, { useEffect, useState } from "react"

//icons
import Icon from "../icons/Icon"

//interfaces
import { IconLibrary } from "../../../interfaces/icon/IconLibrary"
import { ITextInputWithLabel } from "../../../interfaces/textInputs/IBasicTextInput"



const TextInputWithLabelAndPasswordToggle = ({id, label, isPassword, setValue, defaultValue, placeholder, autoComplete, onReturnPressed, onBlur, disabled}: ITextInputWithLabel) => {
    const [v, setV] = useState<string>(defaultValue ?? '');
    const [hidePassword, setHidePassword] = useState<boolean>(isPassword);

    useEffect(() => {
        setValue(v)
    },[v]);

    function handlePasswordToggle(){
        setHidePassword(!hidePassword);
    }

    return (
        <div className="thrive-component-form-element text-with-label">
            <label htmlFor={id}>{label}</label>
            <input
                id={id}
                className={isPassword ? "text-input-area password" : "text-input-area"}
                type={hidePassword ? 'password' : 'text'}
                placeholder={placeholder}
                value={v}
                onChange={(e) => setV(e.target.value)}
                autoComplete={autoComplete}
                onKeyDown={e => {
                    if(e.code === 'Enter') {
                        onReturnPressed?.();
                    }
                }}
                onBlur={onBlur ?? undefined}
                disabled={disabled}
            />
            {isPassword && <button
                name={hidePassword ? 'show password' : 'hide password'}
                aria-label={hidePassword ? 'show password' : 'hide password'}
                className="reveal-password-button"
                onClick={handlePasswordToggle}
                type={'button'}
                disabled={disabled}
                >
                    <Icon
                        iconName={hidePassword ? IconLibrary.EYE_ON: IconLibrary.EYE_OFF}
                        sizeInPx="22"
                    />
                </button>}
        </div>
    )
}

export {TextInputWithLabelAndPasswordToggle}